<body>
    <div>
        <div class="center-container">
            <div class="content-area">
                <!-- Stepper - Sidebar -->
                <div class="sidebar">
                    <div *ngIf="!isEditMode" class="role-title">Create a new scenario</div>
                    <div *ngIf="isEditMode" class="role-title">Editing {{ scenario_name }}</div>
                    <app-stepper [isEditMode]="isEditMode" (changeStepperEvent)="changeStepper($event)"></app-stepper>
                </div>
                <!-- Form Elements-->
                <div class="container">
                    <div class="inner-container">
                        <form [formGroup]="step3Form" (ngSubmit)="goToStep(4)" class="stepper3-form">
                            <div class="title">
                                <div class="tell-us-block">
                                    <span class="paraTell">Customer's Perception</span>
                                </div>
                                <div class="inner-block">
                                    <div class="cust">
                                        <label class="labels">Customers values about the product:</label>
                                    </div>
                                    <div formArrayName="customerValues">
                                        <div class="cust row-1"
                                            *ngFor="let objective of customerValues.controls; let i = index">
                                            <input class="input-box" type="text" [formControlName]="i"
                                                placeholder="Add new Customer Values">
                                            <img class="jj-close" (click)="removeInput(i, 'V')"
                                                src="../../../../assets/images/JJ_Icon_Close.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="checkbox-list">
                                        <button type="button" (click)="addValueInput()">Add New +</button>
                                    </div>
                                    <div class="cust">
                                        <label class="labels">Concerns about the product:</label>
                                    </div>
                                    <div formArrayName="concernsAbout">
                                        <div class="cust row-1"
                                            *ngFor="let objective of concernsAbout.controls; let i = index">
                                            <input class="input-box" type="text" [formControlName]="i"
                                                placeholder="Add new Concerns">
                                            <img class="jj-close" (click)="removeInput(i, 'C')"
                                                src="../../../../assets/images/JJ_Icon_Close.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="checkbox-list">
                                        <button type="button" (click)="addConcernInput()">Add New +</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
                <div class="cancel-button" (click)="goBack()">&times;</div>
            </div>
            <div class="footer-step1">
                <div class="secondary-button" (click)="goToStep(2)">
                    <div>Previous</div>
                </div>
                <div class="primary-button" (click)="goToStep(4)">
                    <div>Next</div>
                </div>
            </div>
        </div>
    </div>
</body>